import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UserSaved } from 'src/app/models/user.model';
import { WarehouseAdministrativeService } from 'src/app/services/warehouse-administrative.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { ResponseObject } from 'src/app/models/response-object.model';


@Component({
  selector: 'app-administrative-warehouse',
  templateUrl: './administrative-warehouse.component.html',
  styleUrls: ['./administrative-warehouse.component.scss']
})
export class AdministrativeWarehouseComponent {

  administrativeId = null;
  fiscalId = null;
  isAdministrative = false;
  warehousesAdministrative = [];
  user: UserSaved = null;
  warehousesFiscales = [];
  originalRelations = [];

  constructor(
    private warehouseAdministrativeService: WarehouseAdministrativeService,
    private warehouseService: WarehouseService,
    private toastService: ToastrService,
    private authService: AuthenticationService,
  ){
    this.isAdministrative = JSON.parse(this.authService.getCurrentCompany()).administrative;
    this.user = this.authService.getUser();
    this.loadStartData();
  }

  loadStartData() {
    this.getWarehousesAdmin();
  }

  getWarehousesAdmin() {
    this.warehouseService.getWarehouses().subscribe({
      next: (response: ResponseObject) => {
        this.warehousesAdministrative = response.data.filter(w => w.name != "Bodega por defecto");;
        this.getWarehouseFiscales();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message || 'Error al obtener las bodegas administrativas');
      }
    });
  }

  getWarehouseFiscales() {
    this.warehouseAdministrativeService.getAllFiscalWarehouses(this.authService.getCurrentCompanyId()).subscribe({
      next: (response: ResponseObject) => {
        // this.warehousesFiscales = response.data.filter(w => w.name != "Bodega por defecto"); 
        this.warehousesFiscales = response.data;
        this.originalRelations = this.warehousesFiscales
          .filter(f => f.warehouseAdminId)
          .map(f => ({ fiscalId: f.id, adminId: f.warehouseAdminId }));
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message || 'Error al obtener las bodegas fiscales');
      }
    });
  }


  associateCompanies() {
    const usedAdminIds = new Set<number>();
    const relations = [];

    // Relaciones nuevas seleccionadas
    for (const fiscal of this.warehousesFiscales) {
      const adminId = fiscal.warehouseAdminId;
      if (adminId) {
        usedAdminIds.add(adminId);
        relations.push({ fiscalId: fiscal.id, adminId });
      }
    }

    // Detectar relaciones eliminadas
    const removedRelations = this.originalRelations.filter(
      orig => !relations.some(r => r.fiscalId === orig.fiscalId && r.adminId === orig.adminId)
    );

    // Requests para agregar
    const addRequests = relations.map(r =>
      this.warehouseAdministrativeService.associateWarehouses(r.adminId, r.fiscalId)
    );

    // Requests para borrar
    const deleteRequests = removedRelations.map(r =>
      this.warehouseAdministrativeService.deleteRelation(r.adminId, r.fiscalId)
    );

    Promise.all([...addRequests, ...deleteRequests].map(obs => obs.toPromise()))
      .then(() => {
        this.toastService.success('Relaciones actualizadas correctamente');
        this.getWarehouseFiscales(); // Recargar datos
      })
      .catch((err: HttpErrorResponse) => {
        this.toastService.error(err.error?.message || 'Error al actualizar relaciones');
      });
  }


  onAdminWarehouseSelected(fiscalWarehouse: any) {
    // console.log(`Relacionando fiscal ${fiscalWarehouse.id} con admin ${fiscalWarehouse.warehouseAdminId}`);
    // puedes agregar lógica adicional aquí si es necesario
  }



}
